export function trackAmplitudeEvents(eventName, eventProperties) {
  if (eventName) {
    Domestika.amplitude.trackEvent(eventName, eventProperties);
  } else {
    throw Error("No event to be tracked");
  }
};

/**
 * Convert the String format of Amplitude properties and validates mandatory fields
 * @param {*} amplitudeProps 
 */
export function readAmplitudeProps(amplitudeProps) {
  if (!amplitudeProps) {
    throw Error("No Amplitude props to read!");
  }

  const amplitudeObjProps = JSON.parse(amplitudeProps);
  if (!amplitudeObjProps.eventName) {
    throw Error('The eventName is mandatory for Amplitude Events');
  }

  return amplitudeObjProps;
}
